<template>
  <div ref="container" class="external-html"></div>
</template>

<script>
export default {
  name: 'ExternalHtml',
  props: {
    html: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.renderHtml()
  },
  beforeDestroy() {
    this.clearHtml()
  },
  methods: {
    renderHtml() {
      if (!this.html || !this.$refs.container) {
        return
      }

      this.clearHtml()
      const range = document.createRange()
      range.selectNodeContents(this.$refs.container)
      const fragment = range.createContextualFragment(this.html)
      this.$refs.container.appendChild(fragment)
    },
    clearHtml() {
      if (!this.$refs.container) {
        return
      }

      this.$refs.container.replaceChildren()
    },
  },
  watch: {
    html() {
      this.renderHtml()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/modules/shared/ui/public/ExternalHtml.vue